module.exports = __webpack_public_path__ + "img/MIGRATION.d8226901.svg";